<template>
<div data-v-46e20943="" data-v-2ac6a5fc="" class="news-details-page">
			<div data-v-46e20943="" class="news-details-container">
				<div data-v-46e20943="" class="news-title-wrapper">
					<p data-v-46e20943="" class="title">{{info.title}}</p>
					<p data-v-46e20943="" class="time">{{info.created_at}}</p>
				</div>
				<p data-v-46e20943="" class="news-content" v-html="info.content"></p>
				</div>
		</div>
</template>
<script>
export default {
  name: 'myNewsInfo',
  data() {
    return { info: {}, id: null };
  },
  created() {
    let that = this;
    var query = that.$route.query;
    if (query.id) {
      that.id = query.id;
      that.getInfo();
    }
  },
  methods: {
    getInfo() {
      let that = this;
      let id = that.id;
      that.$parent.showLoading();

       that.$apiFun
        .post('/api/noticeInfo', { id:id })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.info = res.data;
            
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
@import '../../../static/css/chunk-3f7bf009.c75e1438.css';
</style>



// WEBPACK FOOTER //
// src/components/main/myNewsInfo.vue